module.exports = __webpack_public_path__ + "media/npc_dota_hero_oracle.2ddbaebb.webm";